import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';
import { textLength } from '../html-content-properties/text-length';

// break when the text length becomes too large
export const breakOnTooManyCharacters: HtmlContentHeuristic = {
  reason: 'this section has too many characters',
  evaluate: (next: Record<string, any>) => next.textLength > 4000,
  properties: [textLength]
};
